// "Remembered account" for the login screen's welcome-back card — the last
// person to sign in successfully on this browser, shown as a name/email
// chip so returning to /login can skip straight to a password prompt
// instead of the full email+password form. Deliberately separate from
// AuthContext's own `user`/`token` keys: those get wiped on every logout
// (see useLogoutMutation), but this should survive a logout so "welcome
// back" still works for the next sign-in. Never stores a password or token.
const STORAGE_KEY = 'rememberedAccount';

export function getRememberedAccount() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setRememberedAccount({ email, firstName, lastName }) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ email, firstName, lastName })
    );
  } catch {
    // Remembering the account is a convenience, not a requirement — a
    // private-browsing tab or a full storage quota shouldn't block login.
  }
}

export function clearRememberedAccount() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // see setRememberedAccount above
  }
}
